import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCumulativeProductionChartSkeleton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 446,
	height: 169,
	viewBox: "0 0 446 169",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 30,
			y1: 101.5,
			x2: 446,
			y2: 101.5,
			stroke: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 30,
			y1: 9.5,
			x2: 446,
			y2: 9.5,
			stroke: "#EDEDED"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("line", {
				x1: 30,
				y1: 55.5,
				x2: 446,
				y2: 55.5,
				stroke: "#EDEDED"
			})
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 29.5,
			y1: 2,
			x2: 29.5,
			y2: 147,
			stroke: "#E6E8F0"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 446,
			y1: 147.5,
			x2: 29,
			y2: 147.5,
			stroke: "#E6E8F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M351 157.892C351 154.086 354.086 151 357.892 151H409.108C412.914 151 416 154.086 416 157.892V162.108C416 165.914 412.914 169 409.108 169H357.892C354.086 169 351 165.914 351 162.108V157.892Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61 157.892C61 154.086 64.0856 151 67.8919 151H127.108C130.914 151 134 154.086 134 157.892V162.108C134 165.914 130.914 169 127.108 169H67.8919C64.0856 169 61 165.914 61 162.108V157.892Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203 157.892C203 154.086 206.086 151 209.892 151H268.108C271.914 151 275 154.086 275 157.892V162.108C275 165.914 271.914 169 268.108 169H209.892C206.086 169 203 165.914 203 162.108V157.892Z",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 94,
			width: 23,
			height: 18,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 47,
			width: 23,
			height: 18,
			rx: 6.89193,
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 23,
			height: 18,
			rx: 6.89193,
			fill: "#EEEEEE"
		})
	]
});
export default SvgCumulativeProductionChartSkeleton;
